import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  item: {
    padding: theme.spacing(1.5),
  },
  dividerBarraPesquisa: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  dividerBotoes: {
    margin: theme.spacing(4, 0, 3, 0),
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    width: '100%',
  },
  botoesFormularioFicha: {
    justifyContent: 'flex-end',
  },
  mirrorContainer: {


    padding: theme.spacing(1),
  },
  mirrorSeo: {
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  mirrorField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  mirrorLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  mirrorValue: {
    fontSize: '0.95rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
}))

export default useStyles
